import Link from 'gatsby-link';
import React, { Component } from 'react';
import { Button, Image, Menu, Responsive } from 'semantic-ui-react';
import scrolltop from '../assets/img/scrolltop.svg'
import ScrollToTop from 'react-scroll-up'
export default class ScrolloTopFab extends Component {
    render(){
        return (
            <ScrollToTop className="mpost-fab--container" style={{zIndex:99999}} showUnder={160}>
            <Button className="mpost-fab" circular >
                <Image centered size="mini" src={scrolltop} />
            </Button>
            </ScrollToTop>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/ScrollToTopFab.js